import { render } from "./ClinicInfoTab.vue?vue&type=template&id=c28d45b6&scoped=true"
import script from "./ClinicInfoTab.vue?vue&type=script&lang=js"
export * from "./ClinicInfoTab.vue?vue&type=script&lang=js"

import "./ClinicInfoTab.vue?vue&type=style&index=0&id=c28d45b6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c28d45b6"]])

export default __exports__